import { useEffect, useId, useRef, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

export function PracticeDock({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode; className?: string }) {
  const id = useId(), heading = useRef<HTMLHeadingElement>(null);
  const close = useRef(onClose); close.current = onClose;
  const { t } = useTranslation();
  useEffect(() => {
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    heading.current?.focus({ preventScroll: true });
    const escape = (event: KeyboardEvent) => { if (event.key === 'Escape') close.current(); };
    window.addEventListener('keydown', escape);
    return () => { document.body.style.overflow = overflow; window.removeEventListener('keydown', escape); };
  }, []);
  return <aside className="practice-dock" role="region" aria-labelledby={id} data-testid="practice-dock">
    <div className="modal-heading"><h2 id={id} ref={heading} tabIndex={-1}>{title}</h2><button className="icon-button" onClick={onClose} aria-label={t('common.close')}><X size={20} /></button></div>
    {children}
  </aside>;
}
